import { Button } from "../Button";
import { ChevronLeftIcon } from "../Icons";
import { ChevronRightIcon } from "../Icons";
import { Typography } from "../Typography";

interface PaginationControlsProps {
	currentPage: number;
	totalPages: number;
	onNext: () => void;
	onPrev: () => void;
	variant?: "default" | "ape";
}

export const PaginationControls = ({
	currentPage,
	totalPages,
	onNext,
	onPrev,
	variant = "default",
}: PaginationControlsProps) => {
	if (totalPages <= 1) return null;

	return (
		<div className="flex items-center justify-center gap-4 mt-6">
			<Button
				onClick={onPrev}
				disabled={currentPage === 1}
				color="transparent"
				className={variant === "ape" ? "!rounded-lg" : ""}
			>
				<ChevronLeftIcon />
			</Button>

			<Typography>
				{currentPage} / {totalPages}
			</Typography>

			<Button
				onClick={onNext}
				disabled={currentPage === totalPages}
				color="transparent"
				className={variant === "ape" ? "!rounded-lg" : ""}
			>
				<ChevronRightIcon />
			</Button>
		</div>
	);
};
